/* 🤖 this file was generated by svg-to-ts */
export const matIconLastPage: {
  name: 'last-page';
  data: string;
} = {
  name: 'last-page',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M5.59 7.41 10.18 12l-4.59 4.59L7 18l6-6-6-6-1.41 1.41zM16 6h2v12h-2V6z"/></svg>`
};
